import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Layout from '../ui/Layout';
import Card from '../ui/Card';
import Button from '../ui/Button';
import { Recordatorio } from '../../domain/entities/Recordatorio';
import { Invoice } from '../../domain/entities/Invoice';
import './PaymentResultPage.css';

const PaymentFailedPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = (location.state || {}) as {
    recordatorio?: Recordatorio;
    invoice?: Invoice;
    tipo?: string;
    paymentAmount?: number;
  };

  const isRecordatorio = state.tipo === 'RECORDATORIO';
  const recordatorio = state.recordatorio as Recordatorio;
  const invoice = state.invoice as Invoice;
  const transactionDate = new Date().toLocaleDateString('es-CO');

  const handleGoHome = () => navigate('/', { replace: true });
  const handleRetry = () => navigate('/');

  return (
    <Layout>
      <div className="payment-result-container">
        <Card className="payment-result-card">
          <div className="payment-result failed">
            <div className="result-icon failed-icon">✗</div>
            <h2>Pago No Exitoso</h2>

            <div className="transaction-details">
              {isRecordatorio && recordatorio ? (
                <p>{`Número de Recordatorio de pago: RDP${recordatorio.nroRecordatorio}`}</p>
              ) : invoice ? (
                <p>Número de Factura: {invoice.invoiceNumber}</p>
              ) : null}
              <p>Fecha: {transactionDate}</p>
              <p>Estado: <span className="status-failed">Rechazado</span></p>
            </div>

            <p className="result-message">
              Lo sentimos, su pago no pudo ser procesado. Esto puede deberse a:
            </p>

            <ul className="error-reasons">
              <li>Fondos insuficientes</li>
              <li>Datos de tarjeta incorrectos</li>
              <li>Transacción rechazada por el banco</li>
              <li>Problemas de conexión con la entidad financiera</li>
            </ul>

            <div className="action-buttons">
              <Button variant="secondary" onClick={handleGoHome}>
                Volver al Inicio
              </Button>
              <Button onClick={handleRetry}>
                Intentar Nuevamente
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </Layout>
  );
};

export default PaymentFailedPage;
